import { render } from "./MdvFooter.vue?vue&type=template&id=0ef71971&scoped=true"
import script from "./MdvFooter.vue?vue&type=script&lang=js"
export * from "./MdvFooter.vue?vue&type=script&lang=js"

import "./MdvFooter.vue?vue&type=style&index=0&id=0ef71971&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sciam\\Desktop\\Workspaces\\local\\workspace_vue\\mdv-webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef71971"]])

export default __exports__